import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { StarIcon, QuoteIcon } from 'lucide-react';
const testimonials = [{
  name: 'Martín López',
  age: 38,
  specialty: 'Abogado Civil',
  city: 'Córdoba',
  quote: 'Antes perdía horas buscando papeles y mensajes de WhatsApp. Desde que implementé Estudio Jurídico Listo, dejé de perder clientes por falta de seguimiento. El sistema se paga solo.'
}, {
  name: 'Lucía Fernández',
  age: 42,
  specialty: 'Abogada Penal',
  city: 'Rosario',
  quote: 'El nivel de estrés que manejaba era insostenible. Este sistema me devolvió la tranquilidad. Ahora sé exactamente en qué estado está cada caso sin tener que depender de mi memoria.'
}, {
  name: 'Santiago Ruiz',
  age: 35,
  specialty: 'Abogado Laboral',
  city: 'Buenos Aires',
  quote: 'Quería escalar mi estudio pero el desorden me frenaba. Las plantillas y la estructura que te da este producto son oro puro. Pude tomar más casos trabajando menos horas.'
}, {
  name: 'Carolina Méndez',
  age: 45,
  specialty: 'Abogada de Familia',
  city: 'Mendoza',
  quote: 'Había probado con Excel y apps carísimas que nadie en el estudio entendía. Esto es simple, directo y funciona. Por fin siento que tengo el control total de mi despacho.'
}, {
  name: 'Diego Morales',
  age: 31,
  specialty: 'Abogado Comercial',
  city: 'La Plata',
  quote: 'Lo implementé en menos de una semana. La organización de los expedientes y el seguimiento de clientes cambió por completo la imagen profesional que damos. 100% recomendado.'
}];
export function TestimonialsSection() {
  return <section className="bg-navy-light py-16 md:py-24 px-4 relative overflow-hidden" data-id="element-183">
      <div className="max-w-6xl mx-auto" data-id="element-184">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-185">
          <h2 className="text-3xl md:text-5xl font-black text-white mb-6" data-id="element-186">
            Colegas que ya transformaron su estudio
          </h2>
          <p className="text-xl text-gray-400" data-id="element-187">
            Resultados reales de abogados en Argentina
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-188">
          {testimonials.map((t, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-navy-dark p-8 rounded-2xl border border-gold/20 relative group hover:border-gold/50 transition-colors" data-id="element-189">
              <QuoteIcon className="absolute top-6 right-6 w-10 h-10 text-gold/10 group-hover:text-gold/20 transition-colors" data-id="element-190" />

              <div className="flex gap-1 mb-4" data-id="element-191">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-gold text-gold" data-id="element-192" />)}
              </div>

              <p className="text-gray-300 mb-6 relative z-10 italic" data-id="element-193">
                "{t.quote}"
              </p>

              <div className="border-t border-gray-800 pt-4" data-id="element-194">
                <p className="font-bold text-white text-lg" data-id="element-195">
                  {t.name}, {t.age} años
                </p>
                <p className="text-gold text-sm font-medium" data-id="element-196">{t.specialty}</p>
                <p className="text-gray-500 text-sm" data-id="element-197">{t.city}, Argentina</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}